import React from 'react';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectOneModeloFollowUpTable from './QCXSelectOneModeloFollowUpTable';

export default function QCXSelectOneModeloFollowUpFinalFormTable({
  selected = null,
  isConsult,
  handleSubmit,
  handleChange,
  title,
  filterProp,
  columns,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <QCXSelectOneModeloFollowUpTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          selected={selected}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
